import type {
  BrowseCategorySlug,
  BrowseCategory,
  CategoryLink,
} from '@engage/browse-categories';
import { toCategoryLink } from '@engage/browse-categories';
import { useReduxState } from '@engage/redux';
import BrowseCategoryView from './BrowseCategoryView';

export const toConnectedBrowseCategory = <S extends {}>(
  getCategories: GetCategories<S>,
  toCategoryRoute: (slug: BrowseCategorySlug) => string,
) => {
  return () => {
    const categories = useReduxState(getCategories);
    const categoryLinks: CategoryLink[] = categories.map(toCategoryLink(toCategoryRoute));

    return BrowseCategoryView({ categories: categoryLinks });
  };
};

type GetCategories<SelectorState extends {}> = (state: SelectorState) => BrowseCategory[];
